module.exports = __webpack_public_path__ + "static/storeez-banner-aed1a41c4e42b9aa18b660a1e8eefbef.png";